import React, { useState } from 'react';
import { supabase } from '../../utils/supabase';
import { AuthFormProps } from './types';
import './styles.scss';

const LoginForm: React.FC<AuthFormProps> = ({ setAuthView }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const { error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) throw error;
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-form">
      <h2>Welcome Back!</h2>
      <p className="auth-subtitle">Sign in to continue analyzing</p>

      {error && <div className="error-message">{error}</div>}

      <div className="form-content">
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="form-input"
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="form-input"
          required
        />
        <button onClick={handleSubmit} disabled={loading} className="btn btn-primary btn-large">
          {loading ? 'Signing in...' : 'Sign In'}
        </button>
        <div className="form-links">
          <button onClick={() => setAuthView('forgot')} className="link-button">
            Forgot password?
          </button>
          <div>
            Don't have an account?{' '}
            <button onClick={() => setAuthView('signup')} className="link-button">
              Sign up
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
